var _style, _circle, _line, _line2, _circle2, _line3, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:6,6;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:4,4;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;}\r\n\t.st5{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-dasharray:3.1081,3.1081;}\r\n\t\r\n\t\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:4,3;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 7
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    y1: 22,
    x2: 25,
    y2: 22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7,
    y1: 29,
    x2: 14,
    y2: 29
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 15,
    r: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,15.1l-2-2.8L12,3L3,15.6C5.4,18,7.2,21.3,8,25h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenRemove);
export default __webpack_public_path__ + "static/media/pen_remove.357233c5c8ba74be43643d505c100926.svg";
export { ForwardRef as ReactComponent };